export default __webpack_public_path__ + "static/media/Green0003.92518486.png";